module.exports = __webpack_public_path__ + "img/MikroTik-RouterOS.a0c62c9.svg";